import apiHeader from '@/helpers/apiHeader';

const abbreviationService = {
    list(params) {
        return apiHeader.get('dictionary/abbreviation', { params });
    },
    create(params) {
        return apiHeader.post('dictionary/abbreviation', params);
    },
    delete(id) {
        return apiHeader.delete(`dictionary/abbreviation/${id}`);
    },
    detail(id) {
        return apiHeader.get(`dictionary/abbreviation/${id}`);
    },
    patch(id, params) {
        return apiHeader.patch(`dictionary/abbreviation/${id}`, params);
    },
};

export default abbreviationService;
